import { authorizedRequest } from "../../../services/apiClient";

export interface GeoRegion {
  id: string;
  code: string;
  psgc_code?: string | null;
  name: string;
}

export interface GeoProvince {
  id: string;
  region_id: string;
  name: string;
  psgc_code?: string | null;
}

export interface GeoMunicipality {
  id: string;
  province_id: string;
  name: string;
  classification?: string | null;
  psgc_code?: string | null;
}

export interface GeoBarangay {
  id: string;
  municipality_id: string;
  name: string;
  psgc_code?: string | null;
}

export async function listRegions(accessToken: string): Promise<GeoRegion[]> {
  return authorizedRequest<GeoRegion[]>(accessToken, "/geo/regions");
}

export async function listProvinces(
  accessToken: string,
  regionId: string
): Promise<GeoProvince[]> {
  return authorizedRequest<GeoProvince[]>(
    accessToken,
    `/geo/provinces?region_id=${regionId}`
  );
}

export async function listMunicipalities(
  accessToken: string,
  provinceId: string
): Promise<GeoMunicipality[]> {
  return authorizedRequest<GeoMunicipality[]>(
    accessToken,
    `/geo/municipalities?province_id=${provinceId}`
  );
}

export async function listBarangays(
  accessToken: string,
  municipalityId: string
): Promise<GeoBarangay[]> {
  return authorizedRequest<GeoBarangay[]>(
    accessToken,
    `/geo/barangays?municipality_id=${municipalityId}`
  );
}
